/* eslint-disable react/prop-types */
import React, { useState } from "react";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import {
  Dialog,
  DialogTitle,
  FormControl,
  Button,
  makeStyles,
  // FormControlLabel,
  // Checkbox,
  DialogActions,
  DialogContent,
  FormHelperText,
  TextField,
  CircularProgress,
  Snackbar
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import useFormFields from "lib/forms";
import { createUser } from "lib/services/users";
import { CompaniesAutocomplete } from "app/utils/autocomplete";
import RolesAutocomplete from "app/utils/autocomplete/RolesAutocomplete";

const useStyles = makeStyles(theme => ({
  addUserButton: {
    backgroundColor: "#90cb7c"
  },
  button: {
    margin: theme.spacing(1)
  },
  companySelectHelperText: {
    color: "#e86861",
    fontSize: "large",
    fontWeight: "bold"
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative"
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
}));

function Alert(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function AddUserComponent({ onSuccess /* , userPool */ }) {
  const classes = useStyles(() => ({
    dialogContent: {
      padding: "20px"
    }
  }));
  const [open, setOpen] = useState(false);
  const [fields, handleFieldChange, resetFields] = useFormFields({
    email: "",
    // emailVerified: false,
    company_id: "",
    role_ids: []
    // emailInvitation: true
  });
  const [loading, setLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "",
    message: ""
  });

  const handleDialogOpen = () => {
    setOpen(true);
  };

  const handleDialogClose = () => {
    setOpen(false);
    resetFields();
  };

  const handleFormSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const newSnackbarState = {
      open: true,
      severity: "success",
      message: "User created successfully!"
    };

    try {
      await createUser({ ...fields /* , userPool */ });
      handleDialogClose();
      if (onSuccess && typeof onSuccess === "function") onSuccess();
    } catch (error) {
      if (error.response && error.response.data.title === "Conflict") {
        newSnackbarState.severity = "warning";
        newSnackbarState.message =
          "You're late! Email is already in use. Please enter a different one";
      } else {
        newSnackbarState.severity = "error";
        newSnackbarState.message =
          "An error occurred. Please try again shortly";
      }
    } finally {
      setLoading(false);
      setSnackbarState(newSnackbarState);
    }
  };

  const handleSnackbarClose = (_event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarState(prevState => {
      return {
        ...prevState,
        open: false
      };
    });
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="large"
        className={classes.button}
        startIcon={<PersonAddIcon />}
        onClick={handleDialogOpen}
      >
        New User
      </Button>
      <Dialog
        className={classes.dialogContent}
        open={open}
        aria-labelledby="add-user-form-dialog-title"
      >
        <DialogTitle id="add-user-form-dialog-title">
          Create new user
        </DialogTitle>
        <form onSubmit={handleFormSubmit}>
          <DialogContent>
            <FormControl fullWidth required className={classes.formControl}>
              <TextField
                label="Email Address"
                name="email"
                type="email"
                value={fields.email}
                onChange={handleFieldChange}
                required
                fullWidth
              />
              {/* <FormControlLabel
                control={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Checkbox
                    checked={fields.emailVerified}
                    onChange={handleFieldChange}
                    color="primary"
                    name="emailVerified"
                  />
                }
                label="Mark email as verified?"
              /> */}
              <CompaniesAutocomplete
                inputProps={{ required: true, label: "Company" }}
                onChange={company => {
                  fields.company_id = company ? company.id : undefined;
                }}
              />
              <FormHelperText className={classes.companySelectHelperText}>
                {`IMPORTANT: The user will have access to the data of the company
            specified in this field`}
              </FormHelperText>
              <RolesAutocomplete
                onChange={roles => {
                  if (roles.length)
                    fields.role_ids = roles.map(role => role.id);
                }}
                inputProps={{ label: "Roles" }}
              />
              {/* <FormControlLabel
                control={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Checkbox
                    checked={fields.emailInvitation}
                    onChange={handleFieldChange}
                    color="primary"
                    name="emailInvitation"
                  />
                }
                label="Send email invitation?"
              /> */}
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>Cancel</Button>
            <div className={classes.wrapper}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
              >
                Create User
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          </DialogActions>
        </form>
      </Dialog>
      <Snackbar
        open={snackbarState.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarState.severity}>
          {snackbarState.message}
        </Alert>
      </Snackbar>
    </>
  );
}
